<template>
  <div id="footer" class="container-fluid">
    <div class="conpany-content">

      <div class="left">
        <p class="title">杭州莲花科技创新有限公司</p>
        <p class="address common_font">地址：杭州市富阳区银湖街道九大道398号富春硅谷创智中心13号101室楼</p>
        <p class="tel common_font">Tel：15168378487</p>
        <p class="email common_font">邮箱：lhzx@lotusaidc.com</p>
      </div>

      <!-- <p class="copy">Copyright &copy; 2018 - {{ new Date().getFullYear() }} 公司名称</p> -->
      <div class="right">
        <img src="@/assets/img/lhgzh.jpg" alt="">
        <p class="img_more_info common_font">更多信息请关注莲花科创公众号</p>
      </div>
    </div>
    <div class="company-beian">
      <span>版权所有 ©2023  杭州莲花科技创新有限公司</span>
      <a href="https://beian.miit.gov.cn/" target="_blank">
        <span class="beian-span" style="color: #999;">浙ICP备2023038734号</span>
      </a>
      <div class="police-container">
        <img src="http://img.lianhuazixing.com/img/static/zx-police-icon.png" alt="">
        <a href=" https://beian.mps.gov.cn/#/query/webSearch?code=33018302001706" target="_blank">
          <span  style="color: #999;">浙公网安备33018302001706号</span>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  /* height: 150px; */
  color: #fff;
  background: #000;
  overflow: hidden;
  /* position: absolute;
  bottom: 0; */
  display: flex;
  flex-direction: column;
  padding-top: 20px;
  padding-bottom: 20px;
  /* text-align: center; */
}

.conpany-content {
  display: flex;
}
.company-beian {
  text-align: center;
  font-size: 12px;
  color: #999;
}

p {
  margin-top: 3px;
  margin-bottom: 3px;
}

.common_font {
  color: #d3d3d3;
  font-size: 12px;
}

.left {
  margin-left: 60px;

  .title {
    font-size: 20px;
    margin-bottom: 20px;
  }

  .address {
    width: 260px;
  }

}

.right img {
  width: 66px;
  height: 66px;
}

.right {
  display: flex;
  align-items: center;
  margin-left: 60px;

}
.police-container {
  display: inline-block;
}
.police-container img {
  width: 20px;
  height: 20px;
  display: inline-block;
  margin-left: 20px;
}
.img_more_info {
  width: 92px;
  margin-left: 16px;
}

.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
.beian-span {
  margin-left: 30px;
}

@media screen and (max-width: 767px) {
  .title {
    font-size: 20px;
  }
  .company-beian {
    display: flex;
    flex-direction: column;
  }
  .beian-span {
    margin-left: 0;
  }

  .common_font {
    color: #d3d3d3;
    font-size: 12px;
  }

  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
  }

  #footer .conpany-content{
    display: flex;
    flex-direction: column;
    height: unset;
  }

  #footer .right {
    margin-top: 10px;
    margin-bottom: 6px;
  }
}
/* 媒体查询（平板） */
/* @media screen and (min-width: 768px) and (max-width: 996px) {

} */
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue